document.addEventListener('DOMContentLoaded', () => {
  // Sprawdź, czy istnieją elementy .YearAccordion__heading
  const yearAccordionHeadings = document.querySelectorAll('.YearAccordion__heading');
  if (yearAccordionHeadings.length > 0) {
      yearAccordionHeadings.forEach((heading) => {
          heading.addEventListener('click', () => {
              const content = heading.nextElementSibling;
              const parent = heading.parentElement;
              if (content && parent) {
                  parent.classList.toggle('active');
                  heading.classList.toggle('active');
                  content.classList.toggle('active');
              }
          });
      });
  }

  // Sprawdź, czy istnieją elementy .DateAccordion__heading
  const dateAccordionHeadings = document.querySelectorAll('.DateAccordion__heading');
  if (dateAccordionHeadings.length > 0) {
      dateAccordionHeadings.forEach((heading) => {
          heading.addEventListener('click', () => {
              const content = heading.nextElementSibling;
              const parent = heading.parentElement;
              if (content && parent) {
                  parent.classList.toggle('active');
                  heading.classList.toggle('active');
                  content.classList.toggle('active');
              }
          });
      });
  }

  // Sprawdź, czy istnieją elementy .DocumentsName
  const documentNames = document.querySelectorAll('.DocumentsName');
  const documentsPageContent = document.querySelector('.DocumentsPageContent');
  if (documentNames.length > 0) {
      documentNames.forEach((name) => {
          name.addEventListener('click', (event) => {
              event.preventDefault();

              // Usuń klasę active ze wszystkich .DocumentsName
              documentNames.forEach((el) => el.classList.remove('active'));

              // Usuń klasę active ze wszystkich .DocumentsSingle
              const documentsSingle = document.querySelectorAll('.DocumentsSingle');
              if (documentsSingle.length > 0) {
                  documentsSingle.forEach((el) => el.classList.remove('active'));
              }

              // Dodaj klasę active do klikniętego elementu
              name.classList.add('active');

              // Ukryj zawartość .DocumentsPageContent, jeśli istnieje
              if (documentsPageContent) {
                  documentsPageContent.classList.add('hidden');
              }

              // Dodaj klasę active do docelowego elementu
              const targetId = name.getAttribute('target');
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                  targetElement.classList.add('active');
              }
          });
      });
  }
});
